import React from 'react';
import { Paper, Stack } from '@mui/material';
import { Loading } from 'framework/ui/mui-builder';
import OneStopSettings from 'domain/gpo/oneStop/List/Settings';
import { useListContext } from 'framework/list';
import SearchWithKeyboardNavigation from 'domain/gpo/oneStop/List/SearchWithKeyboardNavigation';
import { useDeviceDetectorService } from 'framework/utils';
import { pageContentSx } from 'framework/ui/layout';

interface OneStopListPageLayoutProps {
  header: React.ReactChild;
  filter: React.ReactChild;
  requestsList: React.ReactChild;
}

const MIN_THRESHOLD = 1;

const OneStopListPageLayout = ({ header, filter, requestsList }: OneStopListPageLayoutProps) => {
  const { loading, search: searchString = '' } = useListContext();
  const { isDesktop } = useDeviceDetectorService();
  const isSearchMode = searchString.length >= MIN_THRESHOLD;

  return (
    <Paper elevation={0} sx={pageContentSx}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {header}
        <OneStopSettings />
      </Stack>

      <SearchWithKeyboardNavigation isSearchMode={isSearchMode} />
      {loading ? (
        <Loading />
      ) : (
        !isSearchMode && (
          <Stack direction="row">
            {filter}
            {isDesktop && requestsList}
          </Stack>
        )
      )}
    </Paper>
  );
};

export default OneStopListPageLayout;
